import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CustomerGate } from "@/components/CustomerAuth";
import { getCustomerProfile } from "@/lib/api";

export default function CustomerLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    if (getCustomerProfile()) navigate("/account", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FAF7F0] flex items-center justify-center px-6" data-testid="customer-login-page">
      <div className="w-full max-w-md bg-white border border-[#C5A059]/30 px-8 md:px-12 py-12">
        <div className="flex flex-col items-center mb-8">
          <img src="/assets/logo.png" alt="Australian Luxe" className="w-16 h-16 rounded-full mb-4" />
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#9E7B3A]">Australian Luxe</p>
          <h1 className="font-serif text-3xl font-light mt-2">Your Account</h1>
        </div>
        <CustomerGate heading="Welcome" onAuthed={() => navigate("/account")} />
        <button onClick={() => navigate("/")} data-testid="customer-login-home"
          className="mt-8 text-[10px] tracking-[0.25em] uppercase text-[#4A4A4A]/60 hover:text-[#9E7B3A] transition-colors duration-300">
          ← Back to site
        </button>
      </div>
    </div>
  );
}
